export const collectTags = (subscriptions: { tags?: string[] }[]) => [
  ...new Set(subscriptions.flatMap((sub) => sub.tags ?? [])),
];
